/**
 * The single-select sheet behind the game picker card: the grid list for a
 * Classic pool (admins also see drafts), or the run of games for a Shared
 * grid. Picking closes the sheet.
 */
import { Dialog, Radio, type typeRadioItem } from "@sportsmet/ui";
import type { ReactNode } from "react";

export type typeSquaresPickerSheetProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  /** One line under the title, such as "Only admins see drafts." */
  note?: string | undefined;
  items: readonly typeRadioItem[];
  value: string | null;
  onSelect: (value: string) => void;
};

export const SquaresPickerSheet = (
  props: typeSquaresPickerSheetProps,
): ReactNode => (
  <Dialog
    open={props.open}
    onOpenChange={(open) => {
      if (!open) props.onClose();
    }}
    title={props.title}
    description={props.note}
    autoFocus={false}
  >
    <div data-testid="squares-picker-sheet">
      <Radio
        label={props.title}
        labelHidden
        value={props.value ?? undefined}
        items={props.items}
        onValueChange={(value) => {
          props.onSelect(value);
          props.onClose();
        }}
      />
    </div>
  </Dialog>
);
